import { Component, ComponentInterface, h, Prop, Listen, State } from '@stencil/core';

@Component({
  tag: 'kdx-alert-banner',
  shadow: false,
})
export class StAlertBanner implements ComponentInterface {

	/**
	 * Assigns a required unique id to the banner alert
	 */
	@Prop() alertId: string = "alertBannerId";

	/**
	 * Provides a string for any additional alert classes
	 */
	@Prop() alertClasses: string = "alert-primary";

	/**
	 * Add an icon to the banner
	 */
	@Prop() alertIcon: string;

	/**
	 * If true adds dismissible button and dismiss function
	 */
	@Prop() dismissible: boolean = false;

	@Prop() btnIcon: string;

	/**
	 * Determines if alert should render depending on if the user dismissed it
	 */
	@State() shouldRender: boolean = true;

	/**
	 * When event is emitted set session storage.
	 */
	@Listen('dismissTriggered')
	handleDismissTriggered() {
		sessionStorage.setItem('alert-' + this.alertId, "dismissed");
	}

	componentWillLoad() {
		if (this.dismissible) {
			this.shouldRender = sessionStorage.getItem(`alert-${this.alertId}`) !== "dismissed";
		}
	}

	render() {
		if (this.shouldRender) {
			return (
				<kdx-alert 
					alert-id={this.alertId} 
					alert-classes={this.alertClasses} 
					alert-icon={this.alertIcon}
					btn-icon={this.btnIcon}
					dismissible={this.dismissible}>
					<slot />
				</kdx-alert>	
			);
		} else {
			return (
				<div class="d-none">
					<slot />
				</div>
			);
		}
	}
}